export default "__VITE_ASSET__Doa2Qy0a__"